import styled from 'styled-components';

//width = 100% - 2px to account for the border
const SelectMenu = styled.ul`
    position: absolute;
    top: ${({ hasLabel }) => (hasLabel ? 52 : 31)}px;
    z-index: 1400;
    background-color: white;
    width: calc(100% - 2px);
    border: 1px solid #bcbcbc;
    border-top: none;
    list-style: none;
    box-shadow: -1px 4px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 3px 1px -2px rgba(0, 0, 0, 0.12);
    margin: 0;
    padding: 0;
    max-height: 300px;
    overflow-y: scroll;
    white-space: pre-wrap;
`;

export default SelectMenu;
